import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import { Search } from "@walmart-web/livingdesign-icons"
import { Heading, TextField } from "@walmart-web/livingdesign-components"
import { useFetchData } from "components/Shared/Hooks/react-query/useFetchData"
import Skeleton from "components/UserManagement/components/List/Table/Skeleton"
import { SectionProps } from "components/UserManagement/constants"
import * as interfaces from "components/UserManagement/interfaces"
import Table from "components/UserManagement/components/List/Table"
import "./index.scss"
import Button from "components/Shared/Button"

interface ListProps {
	section: interfaces.AdministrationOptions
	setView: (value: interfaces.Views) => void
	selection: any
	setSelection: (value: any) => void
}

const List: React.FC<ListProps> = ({
	section,
	setView,
	selection,
	setSelection,
}) => {
	const { data = [], isFetching, refetch } = useFetchData<
		interfaces.Users | interfaces.Organizations
	>(`retrieve${section}`, SectionProps[section].endpoint.get)

	const [searchValue, setSearchValue] = useState<string>("")

	return (
		<React.Fragment>
			<Heading UNSAFE_className="title" as="h2">
				<FormattedMessage
					id="phronesis.usermanagement.title"
					values={{ section }}
				/>
			</Heading>

			<div className="subtitle">
				<FormattedMessage
					id="phronesis.usermanagement.subtitle"
					values={{ section }}
				/>
			</div>

			{isFetching ? (
				<Skeleton />
			) : (
				<React.Fragment>
					<div className="search-add">
						<TextField
							className="search"
							label={
								<FormattedMessage
									id="phronesis.usermanagement.search"
									values={{ section }}
								/>
							}
							onChange={(e) => {
								setSearchValue(e.target.value)
							}}
							value={searchValue}
							trailing={<Search style={{ color: "black" }} />}
						/>
						<Button onClick={() => setView("Add")}>
							<FormattedMessage
								id="phronesis.usermanagement.button.add"
								values={{ section }}
							/>
						</Button>
					</div>

					<Table
						section={section}
						selection={selection}
						setSelection={setSelection}
						data={data[section] ?? []}
						searchValue={searchValue}
						refetch={refetch}
						setView={setView}
						dataId={SectionProps[section].id}
						columns={SectionProps[section].columns}
						headers={SectionProps[section].headers}
					/>
				</React.Fragment>
			)}
		</React.Fragment>
	)
}

export default List
